module.exports = "/_next/static/images/mgm-lion-banner-d05ff3dd7af1aea137d08558b5cfe3bd.png";